'use strict';

/**
 * @author Maxim Seredkin
 */

export default ['$rootScope', '$scope', 'MilestoneService',
                function($rootScope, $scope, MilestoneService) {
                    $scope.milestones = [];
                    MilestoneService.api.get({
                                                 filters: [`'status' EQ 'ENABLED'`],
                                                 sorts: ['npp:ASC', 'name:ASC'],
                                             }, (data) => $scope.milestones = data._embedded);
                }]